// extracted by mini-css-extract-plugin
export default {"container":"dLMxmI6qnnJ0OrGnJrmy","busy":"NNHG1EM9Fk0IjF953g8j","label":"WXzBxUAAa3Z6pTjbs_3q","display":"x5tV6gd2WmNYieBsCQK8","spinner":"fbXlsjS42ULV_EnbqOR8"};